import { useEffect, useState } from "react";

import { getProjectFormRelationsApi, createProjectFormRelationApi, updateProjectFormRelationApi, toggleProjectFormRelationApi, deleteProjectFormRelationApi, } from "../apiServices/projectFormRelationServices";

const useProjectFormRelations = (params = {}) => {

  const [relations, setRelations] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchRelations = async () => {

    try {

      setLoading(true);

      const res = await getProjectFormRelationsApi(params);

      setRelations(res?.data?.relations || []);

      setPagination({
        page: res?.data?.page || 1,
        totalPages: res?.data?.totalPages || 1,
        total: res?.data?.total || 0,
      });

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);
    }
  };

  const createRelation = async (data) => {
    const res = await createProjectFormRelationApi(data);
    fetchRelations();
    return res;
  };

  const updateRelation = async (id, data) => {
    const res = await updateProjectFormRelationApi(id, data);
    fetchRelations();
    return res;
  };

  const toggleStatus = async (id, isActive) => {
    const res = await toggleProjectFormRelationApi(id, { isActive });
    fetchRelations();
    return res;
  };

  const deleteRelation = async (id) => {
    const res = await deleteProjectFormRelationApi(id);
    fetchRelations();
    return res;
  };

  useEffect(() => {

    const delay = setTimeout(() => {
      fetchRelations();
    }, 400);

    return () => clearTimeout(delay);

  }, [JSON.stringify(params)]);

  return { relations, pagination, loading, fetchRelations, createRelation, updateRelation, toggleStatus, deleteRelation, };
};

export default useProjectFormRelations;